var map = {
	"./auth.json": "../../packages/i18n/src/tr/auth.json",
	"./banners.json": "../../packages/i18n/src/tr/banners.json",
	"./business-meta.json": "../../packages/i18n/src/tr/business-meta.json",
	"./chat/common.json": "../../packages/i18n/src/tr/chat/common.json",
	"./chat/list.json": "../../packages/i18n/src/tr/chat/list.json",
	"./chat/message.json": "../../packages/i18n/src/tr/chat/message.json",
	"./company/admin.json": "../../packages/i18n/src/tr/company/admin.json",
	"./company/common.json": "../../packages/i18n/src/tr/company/common.json",
	"./company/create.json": "../../packages/i18n/src/tr/company/create.json",
	"./company/options.json": "../../packages/i18n/src/tr/company/options.json",
	"./company/page.json": "../../packages/i18n/src/tr/company/page.json",
	"./company/users.json": "../../packages/i18n/src/tr/company/users.json",
	"./errors.json": "../../packages/i18n/src/tr/errors.json",
	"./group-preview.json": "../../packages/i18n/src/tr/group-preview.json",
	"./landing/companies.json": "../../packages/i18n/src/tr/landing/companies.json",
	"./landing/driver.json": "../../packages/i18n/src/tr/landing/driver.json",
	"./landing/exchange.json": "../../packages/i18n/src/tr/landing/exchange.json",
	"./landing/meta.json": "../../packages/i18n/src/tr/landing/meta.json",
	"./landing/private_exchange.json": "../../packages/i18n/src/tr/landing/private_exchange.json",
	"./landing/shared.json": "../../packages/i18n/src/tr/landing/shared.json",
	"./layout.json": "../../packages/i18n/src/tr/layout.json",
	"./modals.json": "../../packages/i18n/src/tr/modals.json",
	"./offer/actions.json": "../../packages/i18n/src/tr/offer/actions.json",
	"./offer/exchange.json": "../../packages/i18n/src/tr/offer/exchange.json",
	"./offer/form/cargo.json": "../../packages/i18n/src/tr/offer/form/cargo.json",
	"./offer/form/common.json": "../../packages/i18n/src/tr/offer/form/common.json",
	"./offer/form/options.json": "../../packages/i18n/src/tr/offer/form/options.json",
	"./offer/form/transport.json": "../../packages/i18n/src/tr/offer/form/transport.json",
	"./offer/matches.json": "../../packages/i18n/src/tr/offer/matches.json",
	"./offer/my.json": "../../packages/i18n/src/tr/offer/my.json",
	"./offer/own.json": "../../packages/i18n/src/tr/offer/own.json",
	"./offer/preview.json": "../../packages/i18n/src/tr/offer/preview.json",
	"./offer/shared.json": "../../packages/i18n/src/tr/offer/shared.json",
	"./offer/view.json": "../../packages/i18n/src/tr/offer/view.json",
	"./placeholders.json": "../../packages/i18n/src/tr/placeholders.json",
	"./profile/black_list.json": "../../packages/i18n/src/tr/profile/black_list.json",
	"./profile/contact_list.json": "../../packages/i18n/src/tr/profile/contact_list.json",
	"./profile/edit_profile.json": "../../packages/i18n/src/tr/profile/edit_profile.json",
	"./profile/fill_profile.json": "../../packages/i18n/src/tr/profile/fill_profile.json",
	"./profile/my_profile.json": "../../packages/i18n/src/tr/profile/my_profile.json",
	"./profile/my_profile_auth.json": "../../packages/i18n/src/tr/profile/my_profile_auth.json",
	"./profile/profile_form.json": "../../packages/i18n/src/tr/profile/profile_form.json",
	"./profile/shared.json": "../../packages/i18n/src/tr/profile/shared.json",
	"./profile/short_profile.json": "../../packages/i18n/src/tr/profile/short_profile.json",
	"./shared.json": "../../packages/i18n/src/tr/shared.json",
	"./ui.json": "../../packages/i18n/src/tr/ui.json",
	"./validation.json": "../../packages/i18n/src/tr/validation.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../packages/i18n/src/tr sync recursive \\.json$";